import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cdf0688"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ratio ratio-16x9" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src", "alt"]

import useImageServer from '@/composables/useImageServer'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { withDefaults } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImg',
  props: {
    activididadId: null,
    src: null,
    alt: null,
    roundered: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { activididadId?: number, src?: string, alt?: string, roundered: boolean };

const { getPathImageServer } = useImageServer()

const { state } = useStore<VuexStore>(key)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (
        props.activididadId &&
        [46, 76, 115, 123, 70,116,140].includes(props.activididadId)
      )
      ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          class: _normalizeClass(["w-100", { 'rounded-3': props.roundered }]),
          muted: "",
          src: `/video/promo_${props.activididadId}.mp4`,
          autoplay: "",
          controls: ""
        }, null, 10, _hoisted_2))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (props.src)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(getPathImageServer)(props.src),
                alt: props.alt,
                class: _normalizeClass(["card-img-top object-fit-cover", { 'rounded-3': props.roundered }])
              }, null, 10, _hoisted_3))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["placeholder p-3 px-4", { 'rounded-3': props.roundered }])
              }, [
                (_unref(state).evento?.logo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(getPathImageServer)(_unref(state).evento?.logo),
                      alt: props.alt
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ], 2))
        ], 64))
  ]))
}
}

})